import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose } from 'recompose'
import { getClearbitRevealContext } from 'app/modules/enrichment/clearbit/selectors'
import FilterEditor from './component'

import ACCESS, { Gates } from 'utils/Access'

const makeMapStateToProps = () => {

  return (state, props) => {
    const revealContext = getClearbitRevealContext(state)

    return {
      ...props,
      hasFirmographics: revealContext.leadRoutingReveal || ACCESS.hasGates('routing_firmographics'),
      hasSalesforceRouting : ACCESS.hasGates('salesforce_routing_settings_enabled'),
      hasLeandataRouting : ACCESS.hasGates(Gates.LEANDATA),
    }
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({}, dispatch),
})

export default compose(
  connect(makeMapStateToProps, mapDispatchToProps))(FilterEditor)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/FilterEditor/index.js